import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { PobierzDaneDoGenerowaniaRaportuModel } from 'src/app/modele/projekty/arkuszSpisu/pobierzDaneDoGenerowaniaRaportuModel';
import { PobierzDaneDoWyboruRaportuRezultat } from 'src/app/modele/projekty/arkuszSpisu/pobierzDaneDoWyboruRaportuRezultat';
import { RodzajRaportu } from 'src/app/modele/projekty/arkuszSpisu/rodzajRaportu';
import { WygenerujArkuszModel } from 'src/app/modele/projekty/arkuszSpisu/wygenerujArkuszModel';
import { UruchomFiltrPorownywaniaDanychModel } from 'src/app/modele/projekty/magazyny/uruchomFiltrPorownywaniaDanychModel';
import { WygenerujArkuszPorownaniaDanychModel } from 'src/app/modele/projekty/magazyny/wygenerujArkuszPorownaniaDanychModel';
import { KolumnaSpisuFiltrowanie } from 'src/app/modele/projekty/spis/kolumnaSpisuFiltrowanie';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { Routing } from 'src/app/modele/wspolne/routing';
import {
  KierunekSortowania,
  Sortowanie,
} from 'src/app/modele/wspolne/sortowanie';
import { Stronicowanie } from 'src/app/modele/wspolne/stronicowanie';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { ArkuszSpisuService } from 'src/app/serwisy/projekty/arkusz-spisu.service';
import { PorownywanieDanychService } from 'src/app/serwisy/projekty/porownywanie-danych.service';

@Component({
  selector: 'app-generowanie-arkusza-porownanych-danych',
  templateUrl: './generowanie-arkusza-porownanych-danych.component.html',
  styleUrls: ['./generowanie-arkusza-porownanych-danych.component.css'],
})
export class GenerowanieArkuszaPorownanychDanychComponent
  extends BazowyComponent
  implements OnInit
{
  idProjektu: string;
  idLokalizacji: string;
  idFiltra: string;
  miejsceWywolania: string;
  czyZaladowanoDane: boolean;
  adresLokalizacji: string;
  daneDoEkranu: PobierzDaneDoWyboruRaportuRezultat =
    new PobierzDaneDoWyboruRaportuRezultat();
  model: WygenerujArkuszPorownaniaDanychModel =
    new WygenerujArkuszPorownaniaDanychModel();
  czyCalaLokalizacja: boolean;
  czyPokazanoPodmenu: boolean;
  nazwaFiltra: string;

  constructor(
    public router: Router,
    modalService: NgbModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public arkuszSpisuSerwis: ArkuszSpisuService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute,
    private porownywanieDanychSerwis: PorownywanieDanychService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.idLokalizacji =
        this.activatedRoute.snapshot.paramMap.get('idLokalizacji');
      this.idProjektu = this.activatedRoute.snapshot.paramMap.get('idProjektu');
      this.idFiltra = this.activatedRoute.snapshot.paramMap.get('idFiltra');

      if (!this.idFiltra) {
        this.router.navigate([
          Routing.PorownywanieDanych,
          this.idProjektu,
          this.idLokalizacji,
        ]);
        return;
      }

      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    this.porownywanieDanychSerwis
      .pobierzDaneDoGenerowaniaRaportu(
        this.idProjektu,
        this.idLokalizacji,
        this.idFiltra
      )
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.adresLokalizacji = rezultat.element.adresLokalizacji;
          this.model.klient = rezultat.element.klient;
          this.model.lokalizacja = rezultat.element.adresLokalizacji;
          this.model.przewodniczacyZespolu =
            rezultat.element.przewodniczacyZespolu;
          this.model.spisRozpoczetoData = rezultat.element.spisRozpoczetoData;
          this.model.spisRozpoczetoGodzina =
            rezultat.element.spisRozpoczetoGodzina;
          this.model.spisZakonczonoData = rezultat.element.spisZakonczonoData;
          this.model.spisZakonczonoGodzina =
            rezultat.element.spisZakonczonoGodzina;
          this.model.uwagi = rezultat.element.uwagi;
          this.model.kolumny = rezultat.element.kolumny;
          this.nazwaFiltra = rezultat.element.nazwaFiltra;

          this.model.czyDrukowacMpkLokalizacji = true;
          this.model.filtry =
            new RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>();
          this.model.filtry.filtry = new UruchomFiltrPorownywaniaDanychModel();
          this.model.filtry.filtry.idFiltra = this.idFiltra;
          this.model.filtry.filtry.idProjektu = this.idProjektu;
          this.model.filtry.filtry.idLokalizacji = this.idLokalizacji;
          this.pobierzFiltryZUrl();

          this.czyZaladowanoDane = true;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  generuj() {
    this.porownywanieDanychSerwis
      .generujRaport(this.model)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.bledyWalidacji = null;
          var a = document.createElement('a');
          a.target = '_blank';
          a.href = 'data:application/pdf;base64,' + rezultat.element.plik;
          a.download = rezultat.element.nazwaPliku;
          a.click();
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }
        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  anuluj() {
    this.router.navigate([
      Routing.PorownywanieDanych,
      this.idProjektu,
      this.idLokalizacji,
    ]);
  }

  pobierzFiltryZUrl() {
    var filtry = this.activatedRoute.snapshot.queryParamMap;

    this.model.filtry.stronicowanie = new Stronicowanie(true);

    var kierunekSortowania = filtry.get(
      filtry.keys.find((m) => m == 'sortowanieKierunek')
    );
    var kolumnaSortowania = filtry.get(
      filtry.keys.find((m) => m == 'sortowanieKolumna')
    );
    this.model.filtry.sortowanie = new Sortowanie(
      kolumnaSortowania,
      kierunekSortowania.toLocaleLowerCase() == '0'
        ? KierunekSortowania.asc
        : KierunekSortowania.desc
    );
    filtry.keys.forEach((k) => {
      if (
        [
          'strona',
          'rozmiarStrony',
          'sortowanieKolumna',
          'sortowanieKierunek',
        ].includes(k)
      ) {
        return;
      }
      var filtr = {
        kolumna: k,
        wartoscSzukaj: filtry.get(k),
      } as KolumnaSpisuFiltrowanie;
      this.model.filtry.filtry.kolumnyFiltrowania.push(filtr);
    });
  }
}
